import { render } from "./MateriaisView.vue?vue&type=template&id=81c1e918&scoped=true"
import script from "./MateriaisView.vue?vue&type=script&lang=js"
export * from "./MateriaisView.vue?vue&type=script&lang=js"

import "./MateriaisView.vue?vue&type=style&index=0&id=81c1e918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c1e918"]])

export default __exports__